let youtubeApiLoaded = false;
let youtubeApiCallbacks: (() => void)[] = [];

export default function initVideo(): void {
  Alpine.data('video', () => ({
    player: null as YT.Player | null,
    play() {
      const createPlayer = (): void => {
        this.player = new YT.Player(this.$refs.video, {
          videoId: this.$refs.video.dataset.videoId,
          host: 'https://www.youtube-nocookie.com',
          width: this.$refs.videoHolder.clientWidth,
          height: this.$refs.videoHolder.clientHeight,
          playerVars: {
            autoplay: 1,
            controls: 1,
            mute: 0,
            rel: 0,
            loop: 0,
          },
          events: {
            onReady: (event: { target: YT.Player }) => {
              event.target.playVideo();
              this.$refs.image.classList.add('opacity-0', 'hidden');
              this.$refs.videoHolder.classList.add('opacity-100');
              this.$refs.videoHolder.classList.remove('pointer-events-none');
              this.$el.classList.add('hidden');
            },
          },
        });
      };

      if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
        youtubeApiCallbacks.push(createPlayer);
        if (!youtubeApiLoaded) {
          youtubeApiLoaded = true;
          // @ts-expect-error: onYouTubeIframeAPIReady is not globally defined
          window.onYouTubeIframeAPIReady = (): void => {
            youtubeApiCallbacks.forEach((cb) => cb());
            youtubeApiCallbacks = [];
          };
          const tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
        }
      } else {
        createPlayer();
      }
    },
  }));
}
